import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const SETTING_SERVICES_ENDPOINTS = {
  V1: createEndpoints('v1', {
    UNIT_OF_MEASUREMENTS: '/admin/unit-of-measurements/',
    UNIT_OF_MEASUREMENT_DETAIL: (id: number) => `/admin/unit-of-measurements/${id}/`,
    ROOMS: '/admin/rooms/',
    ROOM_DETAIL: (id: number) => `/admin/rooms/${id}/`,
    FLOORS: '/admin/floors/',
    FLOOR_DETAIL: (id: number) => `/admin/floors/${id}/`,
    NOTE_RECOMMENDATIONS: '/admin/note-recommendations/',
    NOTE_RECOMMENDATION_DETAIL: (id: number) => `/admin/note-recommendations/${id}/`,
    TECHNICAL_PROBLEMS_TYPES: '/admin/technical-problems-types/',
    COMPLETION_STATUSES: '/admin/completion-statuses/',
  }),
} as const;
